import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { TabsVariantType } from '../../../../../../components/tabsV2/types/tabsVariantType';
import { FONT_WEIGHT } from '../../../foundations/typography';
import { TextVariantType } from '../../text/variants';
export const commonTabStateStyles = (FOUNDATIONS, FONT, SHADOWS, styles) => {
    return {
        container: {
            flex_grow: '1',
            flex_shrink: '0',
            min_width: FOUNDATIONS.size_675,
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_00}`,
            display: 'flex',
            justify_content: 'center',
            align_items: 'center',
            cursor: 'pointer',
            position: 'relative',
            focusVisible: {
                border_color: 'transparent',
                //We cannot add this because each tab does not have any border with its parent container, so we just add the color
                // outline: `${FOUNDATIONS.color_effect_focus_100} solid ${FOUNDATIONS.border_100}`,
                outline: 'auto',
                outline_color: FOUNDATIONS.color_effect_focus_100,
                outline_offset: 'unset',
                box_shadow: 'none',
            },
            ...styles.container,
        },
        label: {
            font_variant: TextVariantType.FONT_PARAGRAPH_350,
            color: FOUNDATIONS.color_comp_navigation_primarytabs_font,
            font_weight: FONT_WEIGHT.font_regular,
            ...styles.label,
        },
    };
};
export const getPrimaryStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [TabsVariantType.PRIMARY]: {
            rootContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'row',
                align_items: 'center',
                background_color: FOUNDATIONS.color_exception_neutral_bg_1350,
            },
            tabsContainer: {
                width: '100%',
                display: 'flex',
                flex_direction: 'row',
                align_items: 'center',
                gap: FOUNDATIONS.spacing_250,
                overflow: 'hidden',
                position: 'relative',
            },
            selectedTabBorderContainer: {
                background: FOUNDATIONS.color_comp_navigation_primarytabs_selected_border,
                position: 'absolute',
                height: FOUNDATIONS.border_150,
                bottom: '0px',
                transition: `left ${FOUNDATIONS.duration_175} ease-in-out, width ${FOUNDATIONS.duration_175} ease-in-out`,
            },
            leftArrowContainer: {
                display: 'flex',
                align_items: 'center',
                justify_content: 'center',
                padding_left: FOUNDATIONS.spacing_100,
            },
            leftArrow: {
                active: {
                    height: FOUNDATIONS.size_350,
                    width: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                },
                disabled: {
                    height: FOUNDATIONS.size_350,
                    width: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
            rightArrowContainer: {
                display: 'flex',
                align_items: 'center',
                justify_content: 'center',
                padding_right: FOUNDATIONS.spacing_100,
            },
            rightArrow: {
                active: {
                    height: FOUNDATIONS.size_350,
                    width: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_exception_accent_default_secondary_icon_100,
                },
                disabled: {
                    height: FOUNDATIONS.size_350,
                    width: FOUNDATIONS.size_350,
                    color: FOUNDATIONS.color_accent_disabled_icon_100,
                },
            },
            tab: {
                DEFAULT: commonTabStateStyles(FOUNDATIONS, FONT, SHADOWS, {
                    container: {
                        background_color: FOUNDATIONS.color_comp_navigation_primarytabs_unselected_bg,
                    },
                }),
                HOVER: commonTabStateStyles(FOUNDATIONS, FONT, SHADOWS, {
                    container: {
                        background_color: FOUNDATIONS.color_comp_navigation_primarytabs_unselected_bg,
                    },
                }),
                PRESSED: commonTabStateStyles(FOUNDATIONS, FONT, SHADOWS, {
                    container: {
                        background_color: FOUNDATIONS.color_comp_navigation_primarytabs_hover_bg,
                    },
                }),
                SELECTED: commonTabStateStyles(FOUNDATIONS, FONT, SHADOWS, {
                    container: {
                        background_color: FOUNDATIONS.color_comp_navigation_primarytabs_unselected_bg,
                    },
                    label: {
                        font_variant: TextVariantType.FONT_PARAGRAPH_400,
                        font_weight: FONT_WEIGHT.font_bold,
                    },
                }),
                DISABLED: commonTabStateStyles(FOUNDATIONS, FONT, SHADOWS, {
                    container: {
                        background_color: FOUNDATIONS.color_accent_disabled_bg_200,
                        cursor: 'default',
                    },
                    label: {
                        color: FOUNDATIONS.color_accent_disabled_font_50,
                    },
                }),
            },
            animatedHoveredTabContainer: {
                position: 'absolute',
                left: '0',
                right: '0',
                bottom: '0',
                background_color: FOUNDATIONS.color_comp_navigation_primarytabs_hover_bg,
                transition: `height ${FOUNDATIONS.duration_175} ease-out`,
                [DeviceBreakpointsType.TABLET]: {
                    display: 'none',
                },
                [DeviceBreakpointsType.MOBILE]: {
                    display: 'none',
                },
            },
        },
    };
};
//# sourceMappingURL=primary.js.map